import PropTypes from 'prop-types';
import { useDevice } from '../../../hooks/useResponsive';
import CategoryWeb from './categoryWeb';
import CategoryMobile from './categoryMobile';

export default function Category({ category, categoryLoading }) {
  const { isMobile } = useDevice();
  return (
    <>
      {isMobile ? (
        <CategoryMobile category={category} categoryLoading={categoryLoading} />
      ) : (
        <CategoryWeb category={category} categoryLoading={categoryLoading} />
      )}
    </>
  );
}
Category.propTypes = {
  category: PropTypes.object,
  categoryLoading: PropTypes.any,
};
